import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface ContactInfo {
  name: string;
  email: string;
}

interface Access {
  serviceCode: string;
  serviceId: string;
  serviceName: string;
  serviceDescription: string;
}
interface UserState {
  companyId: string;
  groupDescription: string;
  groupName: string;
  id: string;
  isActive: boolean;
  parentCompanyId: string;
  contactInfo: ContactInfo;
  companyName: string;
  access: Access[];
}

const initialState: UserState = {
  companyId: "",
  groupDescription: "",
  groupName: "",
  id: "",
  isActive: false,
  parentCompanyId: "",
  companyName: "",
  contactInfo: {
    name: "",
    email: "",
  },
  access: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData(state, action: PayloadAction<UserState>) {
      state.companyId = action.payload.companyId;
      state.groupDescription = action.payload.groupDescription;
      state.groupName = action.payload.groupName;
      state.id = action.payload.id;
      state.isActive = action.payload.isActive;
      state.parentCompanyId = action.payload.parentCompanyId;
      state.contactInfo = action.payload.contactInfo;
      state.companyName = action.payload.companyName;
      state.access = action.payload.access;
    },
  },
});

export const { setUserData } = userSlice.actions;

export default userSlice.reducer;
